import { createTestId } from 'utils';
import React, { useContext, useState, useEffect } from 'react'
import * as Icon from "react-feather"

import logo from "assets/img/kh-colored-logo.png"
import AsidePanel from "../AsidePanel"
import Sidebar from './Sidebar'
import ProfileDropDown from "./ProfileDropDown"
import LanguageDropDown from './LanguageDropDown'
import { OnlyIconButton } from 'components/button'
import ISpinner from 'components/spinner/spinner'
import { publish } from 'utils/global-events'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import WebClient from 'utils/webclient'
import Notifications from './Notifications'
import { AppContext } from 'configuration/app-context'
import { ThemeContext } from 'configuration/theme-context'

import { Formik } from "formik"
import * as Yup from "yup"
import DoctorDetail from 'project/views/doctor/doctor-detail'
import HospitalDetail from 'project/views/hospital/hospital-detail'
import DepartmentDetail from 'project/views/department/department-detail'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import * as Redux from "utils/redux-store"
import { setDashboardCounts } from 'utils'


const hideOnChildProfile = ["/packages"]

const Layout = ({ children, className }) => {

    const { translate, showDialog } = useContext(AppContext)
    const { theme } = useContext(ThemeContext)
    const [showNotifications, setShowNotifications] = useState(false)
    const [showSearchResult, setShowSearchResult] = useState(false)
    const [searchResult, setSearchResult] = useState([])
    const member = useSelector((state) => state.member);
    const patient = useSelector((state) => state.patient);
    const alert = useSelector(state => state.alert)
    const [showWarnings, setShowWarnings] = useState(false)
    const basketCount = useSelector(state => state.basketCount)
    const notificationCount = useSelector(state => state.notificationCount)

    const navigate = useNavigate()
    const location = useLocation()

    const [showItemDetail, setShowItemDetail] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)

    if (member.patientId != member.profileId && hideOnChildProfile.includes(location.pathname)) navigate("/")

    useEffect(() => {
        setDashboardCounts({type: 'all'})
        /**  */
    }, [])

    return (
        <div className="wrapper">
            <Sidebar />

            <div className="content-wrapper">

                <div className="navbar">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2 grow">
                            <NavLink data-testid={createTestId('NavLink', 'Layout', 'logo')} to="/" id="logo">
                                <img src={logo} alt="Koç Healthcare" />
                            </NavLink>
                            <OnlyIconButton
                                data-testid={createTestId('onlyiconbutton', 'Layout', 1)} onClick={() => {
                                    publish("onOpenSidebar")
                                }}
                                className="md:hidden w-8 h-8 bg-primary-800">
                                <Icon.Menu size={20} />
                            </OnlyIconButton>
                            <div className="search-bar">

                                <Formik
                                    initialValues={{
                                        search: ""
                                    }}
                                    validationSchema={Yup.object().shape({
                                        search: Yup.string().required(translate("validation_message_empty_search")).min(2, translate("validation_message_empty_search"))
                                    })}
                                    onSubmit={(values, { setSubmitting, resetForm, setError, setFieldValue }) => {
                                        setSubmitting(true)
                                        let c = new WebClient()
                                        c.post("50206DA13DD76C/GetFilterOptions", {
                                            keys: ["HospitalKeys", "DoctorKeys", "DepartmentKeys"],
                                            search: values.search
                                        }, false, false, false)
                                            .then(({data, isSuccess, exception}) => {
                                                if (isSuccess) {

                                                    if (data.length == 0) {
                                                        showDialog(
                                                            translate("warning"),
                                                            translate("no_search_records_found"),
                                                            "warning",
                                                            false,
                                                            translate("ok"),
                                                            () => {

                                                            }
                                                        )
                                                    } else {
                                                        setSearchResult(data)
                                                        setShowSearchResult(true)
                                                        resetForm()
                                                    }

                                                } else {
                                                    showDialog(
                                                        translate("warning"),
                                                        translate("no_search_records_found"),
                                                        "warning",
                                                        false,
                                                        translate("ok"),
                                                        () => {

                                                        }
                                                    )
                                                }
                                                setSubmitting(false)
                                            }).catch(() => {
                                                setSubmitting(false)
                                            })
                                    }}
                                >
                                    {({ errors, touched, values, isSubmitting, handleChange, handleSubmit, setValues, handleBlur, setFieldValue, submitForm, resetForm, setErrors }) => (
                                    <form className={classNames("search-form rounded-none md:rounded-3xl", {
                                        "ring-1": touched.search && errors.search,
                                        "ring-red-500": touched.search && errors.search
                                    })} onSubmit={(e) => {
                                        e.preventDefault()
                                        handleSubmit()
                                    }}>
                                        <input
                                            data-testid={createTestId('input', 'Layout', 'search')}
                                            type="text"
                                            className="form-control w-full rounded-none md:rounded-3xl border-none"
                                            value={values.search}
                                            onChange={(e) => setFieldValue("search", e.target.value)}
                                            placeholder={translate("main_search_placeholder")}
                                        />
                                        <button
                                            type="button"
                                            disabled={isSubmitting}
                                            data-testid={createTestId('button', 'Layout', 2)} onClick={() => handleSubmit()}
                                            className="search-submit">
                                            {isSubmitting ? <ISpinner /> : <Icon.Search className="text-primary-700" />}
                                        </button>
                                    </form>
                                    )}
                                </Formik>

                            </div>
                        </div>
                        <ul className="nav navbar-nav">
                            <li className="nav-item">
                                <LanguageDropDown />
                            </li>

                            {
                                theme != "theme-codeLotus" && (
                                    <>
                                        {
                                        member.patientId == member.profileId && (
                                        <>
                                        <li className="nav-item">
                                            <button className="nav-link nav-icon" data-testid={createTestId('button', 'Layout', 3)} onClick={() => {
                                                setShowNotifications(true)
                                            }}>
                                                <Icon.Bell className="text-secondary-700 w-5 h-5" />
                                                {notificationCount > 0 && <span className='badge'>{notificationCount ?? 0}</span>}
                                            </button>
                                        </li>
                                        </>
                                        )
                                        }

                                        <li className='nav-item'>
                                            <button
                                                data-testid={createTestId('button', 'Layout', 4)} onClick={() => {
                                                    navigate('/basket')
                                                }}
                                                className='nav-link nav-icon'
                                            >
                                                <Icon.ShoppingBag className='text-secondary-700 w-5 h-5' />
                                                {basketCount > 0 && <span className='badge'>{basketCount ?? 0}</span>}
                                            </button>
                                        </li>
                                    </>
                                )
                            }

                            <li className="nav-item">
                                <ProfileDropDown />
                            </li>
                        </ul>
                    </div>
                </div>

                {children}

                <AsidePanel
                    title={ showNotifications ? translate("notifications") : translate("messages") }
                    showAside={showNotifications || showWarnings}
                    close={() => { setShowNotifications(false) || setShowWarnings(false) }}>

                    {
                        showNotifications && <Notifications />
                    }


                </AsidePanel>

                <AsidePanel
                    title={translate("search_result")}
                    showAside={showSearchResult}
                    close={() => { setShowSearchResult(false) }}
                >

                    {
                    searchResult.map((s) => {
                        return (
                        <div key={s.key} className="w-full">
                            <h4 className="font-normal text-xl text-secondary-600 mb-4">{s.key == "InsuranceKeys" ? translate("insurance_companies") : s.title}</h4>
                            {
                            s.data.map((d) => {
                                return (
                                    <div
                                        key={s.key + "-" + d.value}
                                        data-testid={createTestId('div', 'Layout', 5)} onClick={() => {
                                            if (s.key == "AppointmentTypeKeys") {
                                                navigate("/appointment", {state: { appointmentTypeId: d.value }})
                                            } else {
                                                setSelectedItem({...d, key: s.key})
                                                setShowItemDetail(true)
                                            }
                                        }}
                                        className="w-full bg-white shadow-md rounded-lg cursor-pointer mb-4 text-primary-800 flex flex-row items-center justify-between p-4 hover:bg-neutral-100"
                                    >
                                        <div className='flex flex-row items-center justify-start'>
                                            {
                                            d.subItem != null && (
                                            <div className="w-16 h-10 mr-2" style={{ backgroundImage: "url("+ d.subItem.logo +")", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "left center" }}>

                                            </div>
                                            )
                                            }
                                            <div>
                                                <p className="font-semibold text-sm inline-block w-full">{d.text}</p>
                                                {d.subItem != null && (
                                                    <p className="inline-block text-sm font-normal">{d.subItem.name}</p>
                                                )}
                                            </div>
                                        </div>

                                        <Icon.ChevronRight size={16} />
                                    </div>
                                )
                            })
                            }
                        </div>
                        )
                    })
                    }

                </AsidePanel>

                <AsidePanel
                    title={selectedItem?.text}
                    showAside={showItemDetail}
                    close={() => { setShowItemDetail(false) }}>

                        {
                        selectedItem?.key == "DoctorKeys" ?
                        <DoctorDetail id={selectedItem?.value} />
                        :
                        selectedItem?.key == "HospitalKeys" ?
                        <HospitalDetail id={selectedItem?.value} />
                        :
                        selectedItem?.key == "DepartmentKeys" ?
                        <DepartmentDetail id={selectedItem?.value} />
                        :
                        null
                        }

                </AsidePanel>

                {
                    (alert && patient?.patientRemindersAndWarnings[0]?.message != null) && (
                        <div className="absolute top-0 right-0 left-0 bg-white shadow-sm alert px-4 lg:px-8 py-2 z-20">
                            <div className='flex items-center justify-between'>
                                <div className='flex items-center space-x-2 text-sm'>

                                    <Icon.XCircle size={16} className="text-red-500 " />
                                    <Link data-testid={createTestId('Link', 'Layout', 'profile')} to="/profile">
                                        {patient?.patientRemindersAndWarnings[0]?.message}
                                    </Link>
                                </div>
                                <button className="close" data-testid={createTestId('button', 'Layout', 6)} onClick={() => Redux.setAlert(false) }>
                                    <Icon.X size={16} />
                                </button>
                            </div>
                        </div>
                    )
                }

            </div>

        </div>
    )
}

export default Layout